import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentUserClientId_session$key } from "./__generated__/useCurrentUserClientId_session.graphql";

export const useCurrentUserClientId = (
  sessionRef: useCurrentUserClientId_session$key | null
) => {
  const session = useFragment(useCurrentUserClientIdFragmentString, sessionRef);
  return session?.currentClientProfile?.member?.id;
};

const useCurrentUserClientIdFragmentString = graphql`
  fragment useCurrentUserClientId_session on Session {
    currentClientProfile {
      member {
        ... on Member {
          id
        }
        ... on Customer {
          id
        }
      }
    }
  }
`;
